<template>
  <!--deviceRuntimeRate 设备运行率-->
  <div class="deviceRuntimeRate">
    <div class="con">
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>选择设备：</span>
                <el-select v-model="value2" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="(item,i) in tempList" :key="i" :label="item.deviceName" :value="item.deviceNo"
                    v-show="tempList[i].status=='ENABLE'">
                  </el-option>
                </el-select>
              </div>
              <div class="input-small mr-20">
                <span>日期类型：</span>
                <el-select v-model="timeType" placeholder="请选择">
                  <el-option label="月" value="month"> </el-option>
                  <el-option label="年" value="year"> </el-option>
                </el-select>
              </div>
              <div class="input-small mr-20">
                <span>日期：</span>
                <el-date-picker v-model="yearTimer" :type="timeType" placeholder="选择日期"
                  :picker-options="pickerOptions"></el-date-picker>
              </div>
              <el-button type="primary" plain @click="getSearch" class="search-btn">查询</el-button>
              <el-button type="success" @click="getSearch2" class="search-btn" :loading="flag"
                style="margin-left: auto !important;">阈值</el-button>
            </div>
          </el-scrollbar>
        </div>
        <div class="mychart" :style="{'width':'100%','height':`${chartHeights}px`}">
          <div id="proportion" style="width:100%;height:100%"></div>
        </div>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改阈值 -->
    <el-dialog title="修改阈值" v-dialogDrag :visible.sync="detail_status" center :close-on-click-modal="false">
      <div style="display: flex;" class="mydialog">
        <el-table :data="tempList" style="width: 100%" height="500px" :row-style="{height: '0'}" stripe
          :cell-style="{padding: '0'}" :header-row-style="{padding: '0'}">

          <el-table-column label="名称">
            <template slot-scope="scope">
              <span>{{ scope.row.deviceName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="阈值" width="130">
            <template slot-scope="scope">
              <el-input style="width:100px;" v-model="scope.row.thresholdValue" type="number"
                placeholder="阈值"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="140">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949"
                active-value="ENABLE" inactive-value="DISABLE" active-text="启用" inactive-text="禁用">
              </el-switch>
            </template>
          </el-table-column>


        </el-table>


        <el-scrollbar style="height:500px;width: 300px;">
          <elUnitTree v-if="detail_status" @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
        </el-scrollbar>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detail_status = false;getList()">取 消
          </el-button>

          <el-button type="primary" @click="submit">保 存
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
  import request from "@/api/http.js";
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import {parseTime} from "@/utils";
  let proportion;
  export default {
    components: {
      elUnitTree
    },
    data () {
      return {
        Option2: {},
        tableData: [],
        value2: '',
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        flag: false,
        rules: {
          thresholdValue: [
            {required: true,message: '请输入阈值',trigger: 'blur'}
          ],
        },
        temp: [],
        tempList: [],
        detail_status: false,
        timeType: 'month',
        loading: false,
        chartHeights: Math.round((document.getElementById('app').clientHeight)*0.81),

        yearTimer: new Date(),

        proportionData: {

          grid: {
            left: '3%',
            right: '3%',
            bottom: '8%',
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: "35",
            top: "20",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: true,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },

          legend: {
            top: '5%'
          },

          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",

            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,

            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [],
          },
          yAxis: {
            type: "value",
          },
          series: [

          ],
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },

      }
    },
    computed: {
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree;
        return isempty(data)? []:[deviceList(data)]
      },

    },
    mounted () {
      for(let i=1;i<=12;i++) {
        this.proportionData.xAxis.data.push(i+'月')
      }
      this.init()
      this.getList()
    },
    methods: {
      checkFun (val) {
        var d=[]
        this.tempList.map((v) => {
          if(v.id) {
            d.push(v)
          }
        })
        this.tempList=d;


        this.temp=[];
        var a=[];
        val.map(v => {
          if(v.type="virtualDevice") {
            a.push(v.no);
            this.tempList.push({
              deviceNo: v.no,
              status: "DISABLE",
              thresholdValue: 0,
              deviceName: v.label
            })

          }
        })
      },
      // 确定修改
      submit () {
        var data=this.tempList;
        request({url: "/runTimeRatio/config/saveDeviceNosRunTimeRatioConfig",method: "post",data}).then(res => {
          if(res.code==200) {
            this.$message({message: '保存成功',type: 'success'});
            this.detail_status=false;
            this.getList()
            this.tempList={}
          }
        })
      },
      // 阈值
      getSearch2 () {
        // this.flag=true;
        // var data={};
        this.detail_status=true;
      },
      getList () {
        request({url: "/runTimeRatio/config/finddeviceNoRunTimeRatioConfig",method: "get"}).then(res => {
          if(res.code==200) {
            this.tempList=res.data;
            this.Option2={};
            this.filterate(this.virtualDeviceList);
            this.tempList.map(v => {
              if(!this.value2.length&&v.status=="ENABLE") {
                this.value2.push(v.deviceNo)
              }
            });
            this.getSearch()
          }
        })
      },
      // 请求数据
      getSearch () {

        var params={
          dateType: this.timeType=='year'? 'YEAR':'MON',
          startTime: '',
          deviceNos: this.value2? this.value2.join(','):''
        }

        if(this.timeType=='year') {
          params.startTime=new Date(parseTime(this.yearTimer,'{y}-01-01 00:00:00')).getTime()
        } else {
          params.startTime=new Date(parseTime(this.yearTimer,'{y}-{m}-01 00:00:00')).getTime()
        }

        this.loading=true;
        request({url: "/runTimeRatio/findOnlineRate",method: "get",params}).then(res => {
          this.loading=false;
          if(res.code==200) {
            var a={}
            this.value2.map(b => {
              this.tempList.map(c => {
                if(b==c.deviceNo) {
                  a[b]=c.deviceNo
                }
              })
            })
            this.proportionData.xAxis.data=[]
            this.proportionData.series=[];
            var aa=[]
            for(const key in res.data) {
              aa.push(key)
              this.proportionData.series.push({
                name: this.Option2[a[key]],
                data: [],
                type: "line",
                stack: "total",
                emphasis: {
                  focus: "series",
                },
              })
            }


            if(this.timeType=='year') {
              for(let i=1;i<13;i++) {
                this.proportionData.xAxis.data.push(i+'月')

              }
              for(const i in res.data[this.value2[0]]) {

                aa.map((v,ii) => {
                  this.proportionData.series[ii].data.push(res.data[v][i])
                })

              }
            } else {
              for(const i in res.data[this.value2[0]]) {
                this.proportionData.xAxis.data.push(i+'日')
                aa.map((v,ii) => {
                  this.proportionData.series[ii].data.push(res.data[v][i])
                })
              }
            }

            proportion.setOption(this.proportionData,true);
          }
        })

      },
      // 过滤树形
      filterate (v) {
        v.map(a => {
          a.disabled=false
          if(a.entityName=="VirtualDevicePojo") {
            this.Option2[a.no]=a.label;
          }
          this.tempList.map(b => {
            if(a.no===b.deviceNo&&a.entityName=="VirtualDevicePojo") {
              a.disabled=true;
            }
          });
          if(a.children&&a.children.length) {
            this.filterate(a.children);
          }
        })

      },
      init () {
        proportion=echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.proportionData,true);

      },


    }
  }
</script>
<style>
  .el-scrollbar__wrap .el-scrollbar__view {
    padding-bottom: 10px;
  }

  .el-scrollbar__bar {
    display: none;
  }

  .el-scrollbar::-webkit-scrollbar {
    display: none !important;
  }
</style>

<style scoped lang="scss">
  .deviceRuntimeRate {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .search-input-btn {
        margin-bottom: 0px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: 100%;
        height: 100%;
        padding: 2px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;
      }
    }
  }
</style>